import { Component, OnInit, Input, Output, EventEmitter, Injectable, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { CommonService } from '../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import * as moment from 'moment';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-add-contenant-tournees',
  templateUrl: './add-contenant-tournees.component.html',
  styleUrls: ['./add-contenant-tournees.component.css']
})
export class AddContenantTourneesComponent implements OnInit {
  showFicheclt: Boolean = false;
  showLeft: Boolean = false;
  showFichechantier: any = false;
  dataClient = [];
  listChantier = [];
  listChantierVille = [];
  selectedEvent: any = {};
  eventSelected: any = {};
  selectedChantier: any = {};
  newprest: any = {};
  step = 1;
  date = new Date();
  addClient: Boolean = false;
  addChantier: Boolean = false;
  isEditChantier: Boolean = false;
  isEditContenant: Boolean = false;
  isModifier: Boolean = false;
  disableModif: Boolean = false;
  isModifDateVidage: Boolean = false;
  listcontenant = [];
  listExutoire = [];
  listChantierBenne = [];
  typeContenant = [];
  listArticle = [];
  newBenne = {};
  groupId = [];
  defaultExutoir: any = false;
  selectContenant = {};
  benneChantier = {};
  typeOperation = [];
  formatPerso = [];
  immatriculationCamionSsChauffeur = '';

  listOperationNew = [
    { id: 0, libelleObjetEntite: 'Depot' },
  ];
  listOperationBenne = [
    { id: 2, libelleObjetEntite: 'Rotation' },
    { id: 1, libelleObjetEntite: 'Retrait' },
  ];
  defaultSelected;
  numBonManuelObligatoire: Boolean = false;
  isVidage: Boolean = false;
  showDate: Boolean = false;
  nbdigit = 0;
  default = 0;
  mouvement: any = {};
  raisonReport = '';
  formatprs: String = '';
  raisonSuppression: String = '';
  error = '';
  listeMouvSupp = [];
  showContrat: Boolean = false;
  isPricipal: Boolean = false;
  isCreateWithBtn: Boolean = false;
  isRetrait: Boolean = false;
  isShowSite: Boolean = false;
  isClicked: Boolean = false;
  notEditable: Boolean = false;
  listeSite = [];
  listeSiteCA = [];
  defaultSite: any = {};

  @Input() info;
  @Input() addContenant;
  @Input() editContenant;
  @Input() edit;
  @Input() isPlanningLocked;
  @Input() isHisto;

  @Output() close = new EventEmitter<any>();
  @Output() updateFct = new EventEmitter<any>();

  @ViewChild('msg') msg;

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.showLeft = true;
    this.defaultExutoir = false;
    this.isPricipal = true;
    this.newprest['isImportant'] = false;
    this.searchTypecontenant();
    this.isCreateWithBtn = true;
    // à ajouter point : 138803 if (this.info && ((this.info['client'] && this.info['client'].id) && !this.info['multiClient']) ) {
    if (this.info && ((this.info['client'] && this.info['client'].id) && !this.info['multiClient']) ) {
      this.notEditable = true;
      this.info['client'].libelleObjetEntite = this.info['client'].libelleObjetEntite || `${this.info['client'].codeClient ?
        this.info['client'].codeClient + '/' : ''} ${this.info['client'].nomClient || ''}`;
      this.setValue(this.info['client'], 'client');
    }
  }



  changeDateStart(event) {
    if (typeof event === 'string' && event.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
      this.newprest['dateStart'] = this.common.parseDate(event);
    }
    if (this.isVidage) {
      this.isModifDateVidage = true;
    }
  }

  modifContentContenant() {
    this.setValue(this.info['contenant'], 'contenant');
    this.editEvent(this.newprest, 5);
  }

  closeFunction() {
    this.isClicked = false;
    this.close.emit();
    this.selectedChantier = {};
    this.newprest = {};
    this.step = 1;
    this.newBenne = {};
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  focusStep() {
    switch (this.step) {
      case 1:
        setTimeout(function () {
          $('.clientCt').focus();
        }, 550);
        break;
      case 2:
        setTimeout(function () {
          $('.villeCt').focus();
        }, 550);
        break;
      case 3:
        setTimeout(function () {
          $('.chantierCt').focus();
        }, 550);
        break;
      case 4:
        setTimeout(function () {
          $('#autofocus').focus();
        }, 550);
        break;
      case 5:
        if (this.newprest['newContenant']) {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        } else {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
    }
  }

  getMargin() {
    let value;
    switch (this.step) {
      case 1:
        value = !this.edit ? '35px' : '-100px';
        break;
      case 2:
        value = !this.edit ? '15px' : '-100px';
        break;
      case 3:
        value = !this.edit ? '2px' : '-100px';
        break;
      case 4:
        value = !this.edit ? '-11px' : '-100px';
        break;
      case 5:
        value = !this.edit ? '-24px' : '-100px';
        break;
      default:
        value = '55px';
    }

    return value;
  }

  countRowsInText(text) {
    if (text) {
      const numerOfRowsInText = text.length ? text.split(/\r*\n/).length : 0;
      return numerOfRowsInText <= 3 ? 3 : 10;
    }
  }

  findCalendar(event) {
    if (event.target.id !== 'autocomplete') {
      if (this.common.dropdown) {
        this.common.dropdown.hide();
      }
    } else {
      if (this.common.dropdown && this.common.dropdown['ouvert']) {
        this.common.dropdown.show();
      }
    }
    if (event.target.id === 'date1' || event.target.id === 'date' || event.target.id === 'date2'
      || event.target.className === 'custom-select' || event.target.className === 'ngb-dp-navigation-chevron') {
      $('ngb-datepicker').addClass('show');
    } else {
      $('ngb-datepicker').removeClass('show');
      $('ngb-datepicker').hide();
    }
  }


  prevStep() {
    if (!this.notEditable) {
      this.step = this.step > 1 ? this.step - 1 : 1;
    } else {
      if (this.step !== 2) {
        this.step = this.step > 1 ? this.step - 1 : 1;
      }
    }
    this.focusStep();
  }

  nextStep() {
    this.step = this.step < 5 ? this.step + 1 : 5;
    this.focusStep();
  }

  setFocuscalendar(event) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
  }

  showFiche() {
    this.showFicheclt = !this.showFicheclt;
  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = {
      'id': this.common.user[2]
    };
    const param = {
      'servlet': 'DBSaveChantierHolding',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBSaveChantierHolding'], event, {
        id: this.newprest['client'] ? this.newprest['client'].id : 0,
        nomclass: 'Client'
      }]
    };
    this.hideChantier();
    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data !== null) {

          if (datas.data[0]) {
            this.getDetailChantier(datas.data[0]).then(dt => {
              this.selectedChantier = event;
              this.common.createLog('108', datas.data[0], true);
              this.setValue(this.selectedChantier, 'chantier');
              setTimeout(function () {
                $('#autocomplete').focus();
              }, 500);
            });
          }
        }
      }
    });
  }

  hourMvt() {
    if (parseInt(this.newprest['hour'], 10)) {
      const heure = (this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00');
      return heure;
    } else {
      if (this.newprest['hour'] === '00') {
        const heure = (this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00');
        return heure;
      } else {
        return (this.newprest['hour']);
      }

    }
  }

  hideChantier() {
    this.isEditChantier = false;
    this.showFichechantier = false;
    this.addChantier = false;
  }

  updateChantier(event) {
    console.log(event);
  }

  showFicheCltadd() {
    this.addClient = !this.addClient;
    this.showFiche();
    if (!this.showFicheclt) {
      setTimeout(function () {
        $('#autocomplete').focus();
      }, 500);
    }
  }

  afterAddClt(event) {
    this.setValue(event, 'client');
    // this.newprest['client'] = event;
  }

  getChantier(id, edit?) {
    if (id) {
      this.getDetailChantier(id).then(datas => {
        this.isEditChantier = edit ? true : false;
        this.showFichechantier = datas.data[0];
        $('#slide-right').trigger('click');
      });
    } else {
      this.isEditChantier = true;
      this.showFichechantier = {};
      this.addChantier = true;
    }
  }

  getDetailChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }

  showCreate() {
    this.newprest['newContenant'] = !this.newprest['newContenant'];
    this.newBenne = {};
    this.newBenne['dateDebutLoc'] = this.common.parseDate(moment().add('days', 1).format('DD/MM/YYYY'));
    this.newBenne['isLocation'] = false;
    this.newprest['contenant'] = false;
    setTimeout(function () {
      $('.combo').click();
    }, 550);
  }

  changeDateTest(event) {
    console.log(event);
  }

  setValue(value, name?) {
    if (this.edit) {
      this.showLeft = false;
      this.isModifier = true;
      setTimeout(function () {
        $('#btnvalider').focus();
      }, 500);
    }
    if (name) {
      this.newprest[name] = value;
    }

    $('#autofocus').focus();
    if (name && name === 'chantier') {
      this.getListeContenant(this.newprest['client'].id, this.newprest['chantier'].numChantier);
    }
    if (name && name === 'newBenne') {
      this.typeOperation = this.listOperationNew;
      this.defaultSelected = this.typeOperation[0];
    }
    if (name && name === 'contenant') {
      this.typeOperation = this.listOperationBenne;
      this.defaultSelected = this.typeOperation[0];
      if (this.newprest['contenant']) {
        if (this.newprest['contenant'].typeContenant) {
          const elt = this.newprest['contenant'].typeContenant;
          this.newprest['contenant'].typeContenant.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') +
            (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') + (elt.uniteCont ? elt.uniteCont.libelle : '');
        }
        if (this.newprest['contenant'].art) {
          this.newprest['contenant'].art.libelleObjetEntite = this.newprest['contenant'].art.libelle;
        }

        if (value.isGroupeArticle && this.newprest['contenant']) {
          this.getGroupeArt(value);
        }
        if (value.isGroupeBenne && this.newprest['contenant']) {
          this.getGroupeBenne(value);
        }
      }
    }
    this.nextStep();

    if (this.step === 5) {
      this.getContenantCht();
      this.selectContenant = this.listcontenant[0];
      setTimeout(function () {
        $('[tabindex=0]').focus();
      }, 500);
    }
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherPrenom': 'true',
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };
    this.common.searchEcoloc({ param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  searchChantier(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'VILLE': this.newprest['chantierVille'] ? (this.newprest['chantierVille'].ville || '') : '',
        'CRITERE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = datas.data;
      }
    });
  }

  searchVille(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'RECHERCHE_VILLE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CRITERE': event
      }
    };
    this.listChantierVille = [];

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        const listChantierVille = [];
        data.forEach((elt, index) => {
          listChantierVille.push({ id: index + 1, libelleObjetEntite: elt || '', ville: elt || '' });
        });
        this.listChantierVille = [...listChantierVille]
      }
    });
  }

  getListeContenant(clt, cht?) {
    this.listChantierBenne = [];
    const param = {
      'servlet': 'DBRechercheClient',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'true',
      'data': ['DBRechercheClient', '' + clt, '' + this.common.user[2], '' + (cht || '')]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        const chantier = datas.data[0].listChantier ? datas.data[0].listChantier : [];
        const listChantier = this.common.sortByText(chantier, 'numChantier');
        this.sortListeBenne(listChantier);
        this.listChantierBenne = listChantier;
        console.log(this.listChantierBenne);
        this.getContenantCht();
      }
    }).catch(error => {
      console.log(error);
    });
  }

  getContenantCht() {
    this.listcontenant = [];
    this.info['listeContenants'] = this.info['listeContenants'] || []; // Liste des contenants mis dans la tournée
    
    this.listChantierBenne.forEach(elt => { // Liste de tous les contenants dans le chantier
      elt.listBenne = elt.listBenne || [];
      if (elt.id === this.newprest['chantier'].id) {
        if (!this.info['article'] || (this.info['article'] && !this.info['article'].id)) {
          elt.listBenne.forEach(benne => {
            // const test = this.info['listeContenants'].filter(t => t.id === benne.id)
            const dejaSurLaTournee = this.benneChantierDejaEnPlaceSurLaTournee(benne, this.info['listeContenants']);            
            if (!benne.isGroupeBenne && !benne.isGroupeArticle && !dejaSurLaTournee) {
              this.listcontenant.push(benne); // Liste des contenants à afficher à choisir dans le schedule pour placer un contenant
            }
          });
        } else {
          if (elt.listBenne) {
            elt.listBenne.forEach(benne => {
              if (benne.art && this.info['article'] && this.info['article'].id && benne.art.id === this.info['article'].id) {
                // this.listcontenant.push(benne);
                // const test = this.info['listeContenants'].filter(t => t.id === benne.id)
                const dejaSurLaTournee = this.benneChantierDejaEnPlaceSurLaTournee(benne, this.info['listeContenants']);
                if (!benne.isGroupeBenne && !benne.isGroupeArticle && !dejaSurLaTournee) {
                  this.listcontenant.push(benne); // Liste des contenants à afficher à choisir dans le schedule pour placer un contenant
                }
              }
            })
          }
        }
      }
    });
  }

  // Regarde si le benneChantier (contenant) est déjà sur la tournée
  benneChantierDejaEnPlaceSurLaTournee(benneChantierATester, listeBenneChantier) {
    let dejaSurLaTournee = false;

    const test = listeBenneChantier.forEach(t => {
        if(t.id === benneChantierATester.id) {
            dejaSurLaTournee = true;
        }

        // Utile quand le contenant est groupé (famille de contenant paramétré en regroup planning)
        // çad qteContenant>0, on doit tester sur les autres benneChantiers du groupe qui est mis dans t.listBacs
        if(!dejaSurLaTournee && t.listBacs && t.listBacs.length) {
            t.listBacs.forEach(t1 => {
                if(t1.id === benneChantierATester.id) {
                    dejaSurLaTournee = true;
                }                  
            });
        }
    });

    return dejaSurLaTournee;
  }

  nextFocus() {
    $('#infosup').focus();
  }

  sortListeBenne(listChantier) {
    listChantier.forEach(elt => {
      if (elt.listBenne) {
        elt.listBenne.sort(function (a, b) {
          if (a.isGroupeBenne || b.isGroupeBenne) {
            return (a.isGroupeBenne === b.isGroupeBenne) ? 0 : a.isGroupeBenne ? -1 : 1;
          } else {
            if (a.typeContenant && b.typeContenant) {
              if (a.typeContenant.famille && b.typeContenant.famille) {
                if (a.typeContenant.famille.libelle < b.typeContenant.famille.libelle) { return -1; }
                if (a.typeContenant.famille.libelle > b.typeContenant.famille.libelle) { return 1; }
              }

              if (a.typeContenant.cubage && b.typeContenant.cubage) {
                if (a.typeContenant.cubage.cubage < b.typeContenant.cubage.cubage) { return -1; }
                if (a.typeContenant.cubage.cubage > b.typeContenant.cubage.cubage) { return 1; }
              }

              if (a.art && b.art) {
                if (a.art.libelle < b.art.libelle) { return -1; }
                if (a.art.libelle > b.art.libelle) { return 1; }
              } else {
                return -1;
              }
            }
          }
          return 0;
        });
      }
    });
  }

  showInfoSupp(event) {
    this.newprest['showInfos'] = true;
    setTimeout(function () {
      $('[autofocus]').focus();
    }, 500);
  }

  changeFocus(event, i, value?) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
    if (event.keyCode === 38 && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
  }

  hideCalendar() {
  }

  searchTypecontenant() {
    this.typeContenant = [];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
      this.typeContenant.push(elt);
    });
  }

  editEvent(event, step, idfocus?) {
    if (this.edit) {
      if (this.isVidage) {
        if (step === 8 || step === 5 || step === 6 || step === 11) {
          this.showLeft = true;
        }
      } else {
        this.showLeft = true;
      }
    }

    if (!this.isVidage) {
      this.step = step;
    } else {
      if (this.showLeft) {
        if (step === 8 || step === 5 || step === 6 || step === 11) {
          this.step = step;
        }
      }
    }

    if (this.step === 3) {
      setTimeout(function () {
        $('#autofocus').focus();
      }, 1000);
    }
  }


  getGroupeArt(benne) {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + benne.id, '1']
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => this.groupId.push('' + elt.id));
        this.newprest['contenant'] = this.newprest['contenant'] || {};
        this.newprest['contenant'].listArticles = datas.data || [];
      }
    });
  }

  getGroupeBenne(benne) {
    const param = {
      'servlet': 'DBGetGroupeBennes',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeBennes', '' + benne.id, '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.newprest['contenant'].listBenne = datas.data || [];
      }
    });
  }

  generatePrestation() {
    const contenant = this.newprest['contenant'];
    console.log(contenant)
    if (contenant) {
      this.updateFct.emit(contenant);
      this.closeFunction();
    }
  }

  closeModalError() {
    this.common.closeModal();
    if (this.isRetrait) {
      this.isRetrait = false;
      this.closeFunction();
    }
  }

  changeFocusCont(event, i) {
    if ((event.keyCode === 40) && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      this.selectContenant = this.listcontenant[i + 1];
    }
    if ((event.keyCode === 38) && event.target.previousElementSibling) {
      this.selectContenant = this.listcontenant[i - 1];
      event.target.previousElementSibling.focus();
    }
  }

  focusDate(isLocation, id, benne?) {
    if (isLocation) {
      this.common.focusElement(id);
    }
  }

  modifContenant() {
    if (this.newprest['newBenne']) {
      this.isEditContenant = !this.isEditContenant;
      setTimeout(function () {
        $('.combo').click();
      }, 550);
    }
    if (this.newprest['contenant']) {
      if (!this.newprest['contenant'].isGroupeArticle && !this.newprest['contenant'].isGroupeBenne) {
        this.isEditContenant = !this.isEditContenant;
        setTimeout(function () {
          $('.combo').click();
        }, 550);
      }
    }
  }

  validerUpdateContenant() {
  }

}
